import React from 'react';

import { menuItemList} from "./NavigationRules";

import {ErrorBoundary} from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";
import './NavigationRow.scss';
import NavigationButton from "root/Header/NavigationButton";
import { useGlobalContext } from "root/Contexts/GlobalContext";

const menuItems = ( user_type ) =>
{
    const menu = menuItemList.filter((rec) =>
    {
        if (rec.userTypes.includes(user_type) && rec.enabled === true)
        {
            return rec;
        }
    })

    return menu.map((item, i) => <NavigationButton key={item.keyName} item={item}/>);
}

const NavigationRow = (props) =>
{
    const {user_type} = useGlobalContext();

    return (
        <ErrorBoundary  FallbackComponent={FallbackComponent}>
           <div className='header-row-bottom'>
               <div className='header-row-menu'>
                   {menuItems(user_type)}
               </div>
           </div>
        </ErrorBoundary>
    )
}

export default NavigationRow;
